import { createFeatureSelector, createSelector } from '@ngrx/store';

import { KN_BR_CONTEXT_CART_FEATURE, KnBrCartContextState } from './kn-br-cart-context.state';

export const getCartContextState = createFeatureSelector<KnBrCartContextState>(KN_BR_CONTEXT_CART_FEATURE);

export const getCartContext = createSelector(getCartContextState, (state: KnBrCartContextState) =>
  state ? state.cartContext : null
);
